import { BlogListingBlockClient } from "./BlogListingBlock.client";
import type { IBlogListingBlockProps } from "./BlogListingBlock.props";

export const BlogListingBlock = (props: IBlogListingBlockProps) => (
  <BlogListingBlockClient {...props} />
);

BlogListingBlock.displayName = "Block::BlogListingBlock";
